import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  idVariant?: string
  className?: string
}

function Batteria56VConnessioneAppEf({ idVariant = '', className }: Props) {
  return (
    <IconBase name="batteria56-v-connessione-app-ef" w={65.617} h={65.619} className={className}>
      <g transform="translate(-38 -39.112)">
        <g>
          <defs>
            <rect
              id={`batteria56vconnessioneappef_${idVariant}_SVGID_1_`}
              x="38"
              y="39.112"
              width="65.617"
              height="65.619"
            />
          </defs>
          <clipPath id={`batteria56vconnessioneappef_${idVariant}_SVGID_2_`}>
            <use
              xlinkHref={`#batteria56vconnessioneappef_${idVariant}_SVGID_1_`}
              overflow="visible"
            />
          </clipPath>
          <path
            clipPath={`url(#batteria56vconnessioneappef_${idVariant}_SVGID_2_)`}
            fill="#9D9D9C"
            d="M71.587,104.73c17.69,0,32.03-14.34,32.03-32.031
      		c0-17.689-14.34-32.03-32.03-32.03s-32.03,14.341-32.03,32.03C39.558,90.391,53.897,104.73,71.587,104.73"
          />
          <path
            clipPath={`url(#batteria56vconnessioneappef_${idVariant}_SVGID_2_)`}
            fill="#E3E5E8"
            d="M70.03,103.174c17.691,0,32.031-14.342,32.031-32.031
      		c0-17.69-14.34-32.031-32.031-32.031C52.34,39.112,38,53.453,38,71.143C38,88.832,52.34,103.174,70.03,103.174"
          />
          <path
            clipPath={`url(#batteria56vconnessioneappef_${idVariant}_SVGID_2_)`}
            fill="#E30613"
            d="M97.375,70.576c0.02,2.368-0.447,4.643-1.334,6.819
      		c-0.677,1.658-1.539,3.234-2.725,4.602c-0.59,0.68-1.165,1.377-1.799,2.012c-0.342,0.342-0.688,0.711-1.2,0.855
      		c-0.663,0.186-1.42-0.309-1.487-0.998c-0.046-0.471,0.066-0.854,0.424-1.184c0.461-0.428,0.909-0.873,1.336-1.336
      		c0.873-0.951,1.625-1.986,2.262-3.117c0.562-1,1.039-2.027,1.322-3.133c0.242-0.939,0.418-1.896,0.58-2.854
      		c0.092-0.539,0.149-1.094,0.133-1.64c-0.039-1.345-0.157-2.684-0.522-3.989c-0.33-1.181-0.716-2.347-1.339-3.399
      		c-0.578-0.978-1.232-1.919-1.93-2.817c-0.51-0.655-1.137-1.221-1.725-1.814c-0.502-0.508-0.518-1.169-0.145-1.752
      		c0.302-0.472,1.291-0.61,1.697-0.215c0.721,0.705,1.461,1.4,2.092,2.184c0.742,0.923,1.436,1.899,2.037,2.919
      		c0.621,1.05,1.104,2.179,1.461,3.358c0.363,1.2,0.649,2.411,0.736,3.664C97.291,69.351,97.334,69.963,97.375,70.576"
          />
          <path
            clipPath={`url(#batteria56vconnessioneappef_${idVariant}_SVGID_2_)`}
            fill="#E30613"
            d="M85.084,62.835c0.002-0.637,0.383-1.017,0.787-1.178
      		c0.512-0.205,1.008-0.096,1.411,0.279c1.191,1.107,2.153,2.391,2.822,3.872c0.407,0.902,0.731,1.844,0.838,2.838
      		c0.074,0.68,0.131,1.362,0.146,2.045c0.033,1.369-0.304,2.673-0.783,3.941c-0.689,1.818-1.86,3.299-3.273,4.602
      		c-0.431,0.398-0.931,0.537-1.494,0.283c-0.465-0.207-0.765-0.682-0.703-1.221c0.045-0.396,0.236-0.701,0.572-0.988
      		c0.737-0.629,1.369-1.371,1.885-2.207c0.612-0.996,1.055-2.059,1.207-3.209c0.104-0.779,0.06-1.581,0.035-2.372
      		c-0.031-1.025-0.357-1.991-0.83-2.882c-0.375-0.705-0.857-1.355-1.334-2c-0.341-0.459-0.764-0.855-1.123-1.303
      		C85.145,63.208,85.135,63.004,85.084,62.835"
          />
          <path
            clipPath={`url(#batteria56vconnessioneappef_${idVariant}_SVGID_2_)`}
            fill="#E30613"
            d="M84.723,70.768c0.025,1.347-0.436,2.496-1.408,3.437
      		c-0.393,0.379-0.835,0.488-1.359,0.318c-0.523-0.172-0.771-0.562-0.83-1.066c-0.039-0.336,0.051-0.664,0.33-0.92
      		c0.484-0.447,0.811-1.003,0.849-1.663c0.041-0.725-0.24-1.35-0.791-1.838c-0.413-0.366-0.463-0.812-0.324-1.321
      		c0.206-0.751,1.28-1.139,1.983-0.547c0.869,0.733,1.322,1.701,1.543,2.789C84.768,70.217,84.723,70.498,84.723,70.768"
          />
          <path
            clipPath={`url(#batteria56vconnessioneappef_${idVariant}_SVGID_2_)`}
            fill="#B2B2B2"
            d="M65.731,92.328c1.246-0.002,2.279-1.037,2.265-2.273
      		c-0.013-1.232-1.014-2.229-2.248-2.236c-1.256-0.01-2.284,0.998-2.291,2.244C63.45,91.299,64.485,92.328,65.731,92.328
      		 M65.728,50.898c1.573,0,3.145,0.001,4.718-0.001c0.585-0.001,0.807-0.238,0.813-0.85c0.005-0.622-0.209-0.861-0.788-0.861
      		c-3.161-0.002-6.322,0.013-9.483-0.012c-0.65-0.005-0.777,0.36-0.786,0.871c-0.011,0.612,0.225,0.851,0.809,0.852
      		C62.583,50.899,64.156,50.898,65.728,50.898 M54.594,84.541h22.269V53.043H54.594V84.541z M54.949,47.016h21.557
      		c0.34,0.12,0.698,0.206,1.02,0.367c1.428,0.718,2.033,1.923,2.033,3.487c-0.004,12.931-0.002,25.86-0.002,38.79
      		c0,0.844,0.006,1.686-0.002,2.527c-0.015,1.215-0.453,2.252-1.465,2.947c-0.471,0.324-1.053,0.482-1.584,0.717H54.949
      		c-0.341-0.121-0.699-0.207-1.02-0.367c-1.432-0.715-2.033-1.924-2.033-3.486c0.003-13.043,0.002-26.083,0.002-39.125
      		c0-0.731-0.007-1.463,0.002-2.193c0.016-1.215,0.452-2.252,1.464-2.948C53.834,47.408,54.417,47.25,54.949,47.016"
          />
        </g>
        <rect x="54.594" y="53.042" fill="#FFFFFF" width="22.269" height="31.498" />
        <g>
          <defs>
            <rect
              id={`batteria56vconnessioneappef_${idVariant}_SVGID_3_`}
              x="38"
              y="39.112"
              width="65.617"
              height="65.619"
            />
          </defs>
          <clipPath id={`batteria56vconnessioneappef_${idVariant}_SVGID_4_`}>
            <use
              xlinkHref={`#batteria56vconnessioneappef_${idVariant}_SVGID_3_`}
              overflow="visible"
            />
          </clipPath>
          <path
            clipPath={`url(#batteria56vconnessioneappef_${idVariant}_SVGID_4_)`}
            fill="#FFFFFF"
            d="M65.729,50.898c-1.573,0-3.145,0.002-4.718-0.001
      		c-0.584-0.001-0.819-0.239-0.808-0.853c0.009-0.51,0.135-0.876,0.786-0.87c3.161,0.024,6.322,0.01,9.483,0.012
      		c0.578,0,0.793,0.239,0.787,0.861c-0.005,0.611-0.227,0.849-0.812,0.85C68.874,50.9,67.3,50.898,65.729,50.898"
          />
          <path
            clipPath={`url(#batteria56vconnessioneappef_${idVariant}_SVGID_4_)`}
            fill="#FFFFFF"
            d="M65.731,92.328c-1.246,0.002-2.281-1.029-2.274-2.266
      		c0.007-1.246,1.035-2.254,2.291-2.244c1.234,0.01,2.235,1.004,2.248,2.236C68.009,91.291,66.978,92.328,65.731,92.328"
          />
        </g>
      </g>
    </IconBase>
  )
}

export default Batteria56VConnessioneAppEf
